export default "__VITE_ASSET__DtQKEoUO__"